import { createContext } from 'react';

import API  from "../../api/api";

interface APIContextType {
  api: API;
}

const APIContext = createContext<APIContextType | null>(null);

export default APIContext;
